import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Arbeitszeit } from '@/domain/termine/shared/types/Arbeitszeit';
import { markierungMapper } from '@/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Markierung } from '@/domain/termine/features/Calendar/shared/TerminInfo/Verknuepfungen/Markierung';
import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { formatArbeitszeitTimeRange } from '@/domain/termine/shared/utils/formatDateTime';

export function TerminVerknuepfungArbeitszeit({
  arbeitszeiten,
}: {
  arbeitszeiten: Arbeitszeit[];
}) {
  return (
    <div className="flex flex-col gap-2 max-h-60 overflow-y-auto">
      {arbeitszeiten.map((arbeitszeit) => (
        <div
          key={arbeitszeit.id}
          className="flex gap-2 items-center justify-between w-full pt-3">
          <div className="flex items-center gap-2">
            <Avatar className="w-9 h-9">
              <AvatarImage
                src={arbeitszeit.mitarbeiter.bildUrl ?? undefined}
                alt={`${arbeitszeit.mitarbeiter.vorname} ${arbeitszeit.mitarbeiter.nachname}`}
              />
              <AvatarFallback>
                <FontAwesomeIcon icon={faUser} size="lg" />
              </AvatarFallback>
            </Avatar>
            <div className="flex flex-col">
              <span className="text-neutrals-900">
                {arbeitszeit.mitarbeiter.vorname}{' '}
                {arbeitszeit.mitarbeiter.nachname}
              </span>
              <div className="flex items-center gap-1 text-xs font-normal text-neutrals-700">
                {arbeitszeit.arbeitsbereich.markierung && (
                  <Markierung
                    color={
                      markierungMapper[arbeitszeit.arbeitsbereich.markierung]
                        .base
                    }
                  />
                )}
                {arbeitszeit.arbeitsbereich.name} ⋅{' '}
                {formatArbeitszeitTimeRange(
                  arbeitszeit.beginn,
                  arbeitszeit.ende,
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
